import * as config from '../data/config'
import LocalStorageHelper from '../common/localStorageHelper';

class FlightDetailsApi {
//debugger;
  static fetchFlightDetails(stationCode) {
    let api = config.environment.api
    let url = api.baseURL + api.getFlightDetailsURL + "/" + stationCode;
     //alert(url)
    let user = LocalStorageHelper.getUser();
    let token = '';
    if (user && user.token) {      
        token = user.token;
        //alert(token)
    }
    return fetch(
      url,
        { headers: { 'Authorization': token }})
    
    .then(response => {
      console.info("kk", response)
    if (response.ok) {        
        return response.json()
    }
    else{
        throw new Error('${response.status}: ${response.statusText}')
    }        
    }).then(payload => {        
          return payload
    })
  }
}
  
export default FlightDetailsApi